import { infoUpdateType } from "types/notifications";
import { useInfoUpdateEvent } from "./useInfoUpdateEvent";

type Params = {
  callback: (data: infoUpdateType) => void
}

export const useAccountingUpdateSocketEvent = ({ callback }: Params) => {
  useInfoUpdateEvent(callback, (data) => (
    data.name === 'Worker' && data.kind === 'workerAccountingLedger'
  ));
};
